import {
    FaFilePdf,
    FaFileExcel,
    FaFileWord,
    FaFileImage,
    FaFilePowerpoint,
    FaFileArchive,
    FaFileAlt,
    FaFile
} from 'react-icons/fa';

export const getFileExtension = (filename) => {
    if (!filename) return '';
    return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
};

export const getFileIcon = (filename) => {
    const ext = getFileExtension(filename);

    switch (ext) {
        case 'pdf':
            return { icon: FaFilePdf, color: 'text-danger' };
        case 'xlsx':
        case 'xls':
        case 'csv':
            return { icon: FaFileExcel, color: 'text-success' };
        case 'doc':
        case 'docx':
            return { icon: FaFileWord, color: 'text-primary' };
        case 'ppt':
        case 'pptx':
            return { icon: FaFilePowerpoint, color: 'text-warning' };
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'svg':
            return { icon: FaFileImage, color: 'text-info' };
        case 'zip':
        case 'rar':
        case '7z':
        case 'tar':
        case 'gz':
            return { icon: FaFileArchive, color: 'text-secondary' };
        case 'txt':
            return { icon: FaFileAlt, color: 'text-muted' };
        default:
            return { icon: FaFile, color: 'text-secondary' };
    }
};
